import { Grid, Skeleton } from '@mantine/core';

import { FormSubsection } from '../../ui/FormSubsection.js';
import { ValidatedTextarea } from '../../form/validatedFields.js';
import type { AccidentForm } from './accidentFormFields.js';

interface AdditionalDataSectionProps {
  form: AccidentForm;
  disabled?: boolean;
  loading?: boolean;
}

export function AdditionalDataSection({ form, disabled, loading }: AdditionalDataSectionProps) {
  if (loading) {
    return (
      <Grid>
        <Grid.Col span={12}>
          <Skeleton height={120} />
        </Grid.Col>
      </Grid>
    );
  }

  return (
    <FormSubsection title="Weitere Angaben">
      <Grid>
        <Grid.Col span={12}>
          <ValidatedTextarea
            form={form}
            field="comments"
            label="14. Kommentare zur Erfassung"
            description="Optionale Anmerkungen oder Erläuterungen"
            disabled={disabled}
            minRows={30}
            autosize
          />
        </Grid.Col>
      </Grid>
    </FormSubsection>
  );
}
